import { render, staticRenderFns } from "./TagUpdate.vue?vue&type=template&id=d98750c6&"
import script from "./TagUpdate.vue?vue&type=script&lang=ts&"
export * from "./TagUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports